/**
 * Onglets des écrans de détail de l'aire Accès (lot L4). L'onglet actif vit dans l'URL (`?tab=`),
 * comme le détail d'un rôle : une capture ou un lien pointe sur l'onglet voulu.
 */
function tabs<const T extends readonly string[]>(ids: T) {
  return {
    ids,
    is: (value: unknown): value is T[number] => typeof value === 'string' && ids.includes(value),
    parse: (value: unknown): T[number] =>
      typeof value === 'string' && ids.includes(value) ? (value as T[number]) : ids[0]!,
  };
}

export const TOKEN_TABS = tabs(['summary', 'rights', 'definition'] as const);
export type TokenTab = (typeof TOKEN_TABS.ids)[number];

export const SECRET_TABS = tabs(['summary', 'definition', 'value', 'access'] as const);
export type SecretTab = (typeof SECRET_TABS.ids)[number];

export const MEMBER_TABS = tabs(['summary', 'definition', 'rights', 'activity'] as const);
export type MemberTab = (typeof MEMBER_TABS.ids)[number];

export const GROUP_TABS = tabs(['summary', 'rights'] as const);
export type GroupTab = (typeof GROUP_TABS.ids)[number];

export const IDENTITY_PROVIDER_TABS = tabs(['summary', 'definition'] as const);
export type IdentityProviderTab = (typeof IDENTITY_PROVIDER_TABS.ids)[number];
